function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagestyle/imagestylecommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { isImage } from '../image/utils';
/**
 * The image style command. It is used to apply different image styles.
 *
 * @extends module:core/command~Command
 */

var ImageStyleCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(ImageStyleCommand, _Command);

  /**
   * Creates an instance of the image style command. Each command instance is handling one style.
   *
   * @param {module:core/editor/editor~Editor} editor The editor instance.
   * @param {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>} styles The styles that this command supports.
   */
  function ImageStyleCommand(editor, styles) {
    var _this;

    _classCallCheck(this, ImageStyleCommand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageStyleCommand).call(this, editor));
    /**
     * The name of the default style, if it is present. If there is no default style, it defaults to `false`.
     *
     * @readonly
     * @type {Boolean|String}
     */

    _this.defaultStyle = false;
    /**
     * A style handled by this command.
     *
     * @readonly
     * @member {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>} #styles
     */

    _this.styles = styles.reduce(function (styles, style) {
      styles[style.name] = style;

      if (style.isDefault) {
        _this.defaultStyle = style.name;
      }

      return styles;
    }, {});
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageStyleCommand, [{
    key: "refresh",
    value: function refresh() {
      var element = this.editor.model.document.selection.getSelectedElement();
      this.isEnabled = isImage(element);

      if (!element) {
        this.value = false;
      } else if (element.hasAttribute('imageStyle')) {
        var attributeValue = element.getAttribute('imageStyle');
        this.value = this.styles[attributeValue] ? attributeValue : false;
      } else {
        this.value = this.defaultStyle;
      }
    }
    /**
     * Executes the command.
     *
     *		editor.execute( 'imageStyle', { value: 'side' } );
     *
     * @param {Object} options
     * @param {String} options.value The name of the style (based on the
     * {@link module:image/image~ImageConfig#styles `image.styles`} configuration option).
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var _this2 = this;

      var styleName = options.value;
      var model = this.editor.model;
      var imageElement = model.document.selection.getSelectedElement();
      model.change(function (writer) {
        // Default style means that there is no `imageStyle` attribute in the model.
        // https://github.com/ckeditor/ckeditor5-image/issues/147
        if (_this2.styles[styleName].isDefault) {
          writer.removeAttribute('imageStyle', imageElement);
        } else {
          writer.setAttribute('imageStyle', styleName, imageElement);
        }
      });
    }
  }]);

  return ImageStyleCommand;
}(Command);

export { ImageStyleCommand as default };